import React from 'react'
import { runInAction } from 'mobx'
import { useLocalStore } from 'mobx-react-lite'
import { format } from 'date-fns'
import api from 'utils/api'

const initialState = {
	date: new Date(),
	enable: [],
	messages: null,
	count: { clap: null, message: null },
}

const countConverter = ({ clap, message }) => ({
	clap: Array.from({ length: 24 }, (v, i) => (clap[i] ? clap[i] : 0)),
	message: Array.from({ length: 24 }, (v, i) => (message[i] ? message[i] : 0)),
})

const actions = {
	async fetch() {
		try {
			const formatted = format(this.date, 'yyyyMMdd')
			const { data } = await api.get(`/api/message.php?date=${formatted}&val=enable:messages:count`)
			runInAction(() => {
				this.enable = data.enable
				this.messages = data.messages
				this.count = countConverter(data.count)
			})
		} catch (e) {
			//
		}
	},
	async handleMonthChange(date) {
		try {
			const formatted = format(date, 'yyyyMMdd')
			const { data } = await api.get(`/api/message.php?date=${formatted}&val=enable`)
			runInAction(() => {
				this.enable = data.enable
			})
		} catch (e) {
			//
		}
	},
	async handleDateChange(date) {
		try {
			this.date = date
			const formatted = format(date, 'yyyyMMdd')
			const { data } = await api.get(`/api/message.php?date=${formatted}&val=messages:count`)
			runInAction(() => {
				this.messages = data.messages
				this.count = countConverter(data.count)
			})
		} catch (e) {
			//
		}
	},
	deleteAll() {
		this.enable = []
		this.messages = null
		this.count = { clap: null, message: null }
	},
}

function createStore() {
	return {
		...initialState,
		...actions,
	}
}

const StoreContext = React.createContext(null)

export function StoreProvider({ children }) {
	const store = useLocalStore(createStore)

	React.useEffect(() => {
		store.fetch()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

function useStore() {
	const store = React.useContext(StoreContext)
	if (!store) {
		throw new Error('에바')
	}
	return store
}

export default useStore
